import { render, staticRenderFns } from "./OverflowedTextPageExtender.vue?vue&type=template&id=d0160c7e&scoped=true&"
import script from "./OverflowedTextPageExtender.vue?vue&type=script&lang=ts&"
export * from "./OverflowedTextPageExtender.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0160c7e",
  null
  
)

export default component.exports